var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _setup.tableName
    ? _c(
        "div",
        { staticClass: "w-100" },
        [
          _vm._l(_setup.itemIds, function (itemId, i) {
            return _c(
              "div",
              {
                key: i,
                staticClass:
                  "mb-1 text-bg-light rounded p-1 small d-flex align-items-center",
              },
              [
                _c("span", { staticClass: "me-2 text-secondary" }, [
                  _vm._v(_vm._s(i + 1) + "."),
                ]),
                _vm._v(" "),
                _c(_setup.FormControlCategoryTitle, {
                  staticClass: "flex-fill",
                  attrs: {
                    "table-name": _setup.tableName,
                    id: parseInt(itemId),
                  },
                }),
                _vm._v(" "),
                _c(_setup.ItemStatusIcons, {
                  attrs: { id: itemId, "table-name": _setup.tableName },
                }),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    staticClass: "ms-2 btn-sm border",
                    attrs: { disabled: i === 0 },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.moveUp(i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-up" })]
                ),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    staticClass: "ms-2 btn-sm border",
                    attrs: { disabled: i === _setup.itemIds.length - 1 },
                    nativeOn: {
                      click: function ($event) {
                        return _setup.moveDown(i)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-chevron-down" })]
                ),
                _vm._v(" "),
                _c(
                  _setup.Button,
                  {
                    staticClass: "ms-2 btn-sm border",
                    nativeOn: {
                      click: function ($event) {
                        return _setup.removeItem(itemId)
                      },
                    },
                  },
                  [_c("i", { staticClass: "bi bi-x" })]
                ),
              ],
              1
            )
          }),
          _vm._v(" "),
          _c(
            _setup.Button,
            {
              staticClass: "btn-sm border",
              nativeOn: {
                click: function ($event) {
                  return _setup.openSelectListModal.apply(null, arguments)
                },
              },
            },
            [_c("i", { staticClass: "bi bi-plus-lg" })]
          ),
        ],
        2
      )
    : !_setup.componentId
    ? _c(
        "small",
        { staticClass: "text-danger form-text ms-2 mb-1 fst-italic small" },
        [_vm._v("Error: No collection targeted")]
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }